export const POST_PRIVACY_OPTIONS = [
  {
    label: "Público",
    key: 'public',
    icon: '#fa-globe'
  },
  {
    label: "No listado",
    key: 'unlisted',
    icon: '#fa-unlock'
  },
  {
    label: "Solo seguidores",
    key: 'private',
    icon: '#fa-lock'
  },
  {
    label: "Directo",
    key: 'direct',
    icon: '#fa-envelope'
  }
]

export const LONG_POST_LENGTH = 1024
export const LONG_POST_TEXT = "Publicación larga"

export const MAX_STATUS_CHARS = 500
